import React from 'react'

const Person = (props: any) => {
  return (
    <svg {...props} width="100%" height="100%" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3_30)">
        <path
          d="M12.922 15C16.2357 15 18.922 12.3137 18.922 9C18.922 5.68629 16.2357 3 12.922 3C9.60829 3 6.922 5.68629 6.922 9C6.922 12.3137 9.60829 15 12.922 15Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.922 20.25C5.73793 17.1122 9.03606 15 12.922 15C16.8079 15 20.1061 17.1122 21.922 20.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_30">
          <rect width="24" height="24" fill="white" transform="translate(0.921997)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Person
